import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    loading: false,

    inquiryId: null,

    messages: [],

    sellerOffer: null,

    agreement: null,

    drawerOpen: false,

    canSend: true,

    buyerMessagesCount: 0,

    sellerMessagesCount: 0,

    archived: false,

    error: null

};

const marketplaceConversationSlice = createSlice({

    name: "marketplaceConversation",

    initialState,

    reducers: {

        loadConversationStart(state) {

            state.loading = true;
            state.error = null;

        },

        loadConversationSuccess(state, action) {

            state.loading = false;

            state.inquiryId = action.payload.inquiryId;

            state.messages = action.payload.messages;

            state.sellerOffer = action.payload.offer;

            state.agreement = action.payload.agreement;

            state.archived = action.payload.archived;

            state.buyerMessagesCount =
                action.payload.messages.filter(

                    m => m.senderType === "BUYER"

                ).length;

            state.sellerMessagesCount =
                action.payload.messages.filter(

                    m => m.senderType === "SELLER"

                ).length;

        },

        loadConversationFailure(state, action) {

            state.loading = false;

            state.error = action.payload;

        },

        appendMessage(state, action) {

            state.messages.push(action.payload);

            if (action.payload.senderType === "BUYER") {

                state.buyerMessagesCount++;

            }

            if (action.payload.senderType === "SELLER") {

                state.sellerMessagesCount++;

            }

            state.canSend =

                state.buyerMessagesCount < 3 ||

                state.sellerMessagesCount < 3;

        },

        setOffer(state, action) {

            state.sellerOffer = action.payload;

        },

        setAgreement(state, action) {

            state.agreement = action.payload;

        },

        archiveConversation(state) {

            state.archived = true;

            state.drawerOpen = false;

        },

        openConversationDrawer(state) {

            state.drawerOpen = true;

        },

        closeConversationDrawer(state) {

            state.drawerOpen = false;

        },

        clearConversation(state) {

            state.inquiryId = null;

            state.messages = [];

            state.sellerOffer = null;

            state.agreement = null;

            state.drawerOpen = false;

            state.archived = false;

            state.buyerMessagesCount = 0;

            state.sellerMessagesCount = 0;

            state.canSend = true;

        }

    }

});

export const {

    loadConversationStart,

    loadConversationSuccess,

    loadConversationFailure,

    appendMessage,

    setOffer,

    setAgreement,

    archiveConversation,

    openConversationDrawer,

    closeConversationDrawer,

    clearConversation

} = marketplaceConversationSlice.actions;

export default marketplaceConversationSlice.reducer;